import * as React from 'react';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import propz from 'propz';
import Moment from 'moment';
import { AppUser } from 'Src/views/App/App';
import { parse } from 'query-string';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Loader } from 'Src/components/Loader/Loader';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { TournamentPublicSiteSettingsSummary } from 'Src/components/TournamentPublicSiteSettingsSummary/TournamentPublicSiteSettingsSummary';
import { TournamentSummary } from 'Src/components/TournamentSummary/TournamentSummary';
import { Button } from 'Src/components/Button/Button';
import { ActionItem } from 'Src/components/ActionsButton/ActionsButton';
import { TournamentEventsSummary } from 'Src/components/TournamentEventsSummary/TournamentEventsSummary';
import { TournamentCompetitorsSummary } from 'Src/components/TournamentCompetitorsSummary/TournamentCompetitorsSummary';
import { TournamentAdminsSummary } from 'Src/components/TournamentAdminsSummary/TournamentAdminsSummary';
import { EmptyComponent } from 'Src/components/EmptyComponent/EmptyComponent';
import { TournamentCustomGroupsSummary } from 'Src/components/TournamentCustomGroupsSummary/TournamentCustomGroupsSummary';
import { TournamentAutoEnrollmentSummary } from 'Src/components/TournamentAutoEnrollmentSummary/TournamentAutoEnrollmentSummary';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { UnsavedChangesModal } from 'Src/components/UnsavedChangesModal/UnsavedChangesModal';
import { TournamentParticipantsSummary } from 'Src/components/TournamentParticipantsSummary/TournamentParticipantsSummary';
import { TournamentEligibleSchoolsSummary } from 'Src/components/TournamentEligibleSchoolsSummary/TournamentEligibleSchoolsSummary';
import { TournamentConfirmationRequestsSummary } from 'Src/components/TournamentConfirmationRequestsSummary/TournamentConfirmationRequestsSummary';
import { TournamentPitchesSummary } from 'Src/components/TournamentPitchesSummary/TournamentPitchesSummary';
import { TournamentEnrollmentLogsSummary } from 'Src/components/TournamentEnrollmentLogsSummary/TournamentEnrollmentLogsSummary';
import { TournamentAddToChampionshipModal } from 'Src/components/TournamentAddToChampionshipModal/TournamentAddToChampionshipModal';
import { TournamentRemoveToChampionshipModal } from 'Src/components/TournamentRemoveToChampionshipModal/TournamentRemoveToChampionshipModal';
import { TournamentTeamsSummary } from 'Src/components/TournamentTeamsSummary/TournamentTeamsSummary';
import { TournamentTVSummary } from 'Src/components/TournamentTVSummary/TournamentTVSummary';
import { TournamentTagAssignModal } from 'Src/components/TournamentTagAssignModal/TournamentTagAssignModal';
import { TournamentTagDeleteModal } from 'Src/components/TournamentTagDeleteModal/TournamentTagDeleteModal';
import { DATE_INTERVAL, DEFAULT_LIMIT, DEFAULT_SKIP, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import {
  INDIVIDUAL_TOURNAMENT_TABS,
  TEAM_TOURNAMENT_TABS,
  TOURNAMENT_FINAL_STAGE,
  TOURNAMENT_GROUP_STAGE,
  TOURNAMENT_GROUP_TAG_MAPPING,
  TOURNAMENT_LAYOUT_TYPE,
  TOURNAMENT_PLAYOFF_STAGE,
  TOURNAMENT_QUALIFIER_STAGE,
  TOURNAMENT_TABS
} from 'Src/consts/tournament';
import { DEFAULT_POINT, EVENT_VENUE } from 'Src/consts/venue';
import { GENDER, MODE_TYPE, TABS } from 'Src/consts/common';
import { AGE_GROUPS } from 'Src/consts/school';
import { TEAM_TYPE } from 'Src/consts/team';
import { LIMIT } from 'Src/consts/table';
import { INVITE_STATUS } from 'Src/consts/invite';
import { INVITE_KIND } from 'Src/consts/invite';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { getAllTournamentParticipants } from 'Src/helpers/service/adminSU/tournamentParticipantsTable';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { History, Location } from 'history';
import {
  deleteTournament,
  getTournamentDeletionCheck,
  getAllTournamentEligibleSchools,
  getAllUpcomingTournaments,
  getCsvListTournamentStudents,
  getUpcomingTournaments,
  getUpcomingTournamentsCount,
  updateTournamentAutoEnrollment,
  updateTournament,
  getTournament,
  downloadTournamentMeetPack,
  assignTournamentEventNumbers
} from 'Src/helpers/service/adminSU/tournamentsTable';
import {
  assignPitchByTournamentIdAndEventId,
  deleteEvent,
  getAllTournamentEvents
} from 'Src/helpers/service/adminSU/tournamentEventsTable';
import { getAllTournamentAdmins } from 'Src/helpers/service/adminSU/tournamentAdminsTable';
import { getEndTime, getSeason } from 'Src/helpers/accessor/accessor';
import { getAllTournamentConfirmationRequests } from 'Src/helpers/service/adminSU/tournamentConfirmationRequestsTable';
import {
  getSelectOptionForSeason,
  getSelectOptionForUpcomingTournamentsSeason,
  getSelectOptionForTournamentTag
} from 'Src/helpers/table/select';
import {
  isIndividualTournament,
  isMiniTeamTournament,
  isTeamTournament
} from 'Src/helpers/tournament/tournament';
import { getTournamentEnrollmentLogs } from 'Src/helpers/service/adminSU/tournamentEnrollmentLogsTable';
import {
  addOrRemoveTournamentsToChampionship,
  getAllChampionships
} from 'Src/helpers/service/adminSU/championshipsTable';
import { activateEvent, addGroupEvents, addTeam, createEvent } from 'Src/helpers/service/admin/event';
import { getAllSchoolUnionTournamentTeams } from 'Src/helpers/service/adminSU/tournamentTeamsTable';
import { getAllSchoolUnionSchools } from 'Src/helpers/service/adminSU/schoolsTable';
import { KIND } from 'Src/consts/school';
import { deleteTournamentGroup, createTournamentGroup } from 'Src/helpers/service/adminSU/tournamentCustomGroupsTable';
import { getPagesCount } from 'Src/helpers/table/table';
import { getSelectOptionForRole, getSelectOptionForTag, getSelectOptionForUserStatus } from 'Src/helpers/table/select';
import { getSpacesWithWl } from 'Src/helpers/tournament/tournament';
import { getSelectOptionForBooleanQuestion } from 'Src/helpers/table/select';
import { uploadReport } from 'Src/helpers/service/admin/report';
import { assignTournamentTag, deleteTournamentTagByTournament } from 'Src/helpers/service/adminSU/tournamentGrid';
import { getTournamentTags } from 'Src/helpers/service/adminSU/tournamentTags';
import { Tournament } from 'Src/models/tournament';
import { EligibleSchool } from 'Src/models/school';
import { TournamentConfirmationRequestMessage } from 'Src/models/message';
import { TournamentTag } from 'Src/models/tournamentTag';
import { Championship } from 'Src/models/championship';
import { INVITE_KIND_TYPE } from 'Src/types/invite';
import { TournamentAutoEnrollmentForm } from '../TournamentAutonrollmentForm/TournamentAutoEnrollmentForm';
import { TournamentPublicSiteSettingsForm } from '../TournamentPublicSiteSettingsForm/TournamentPublicSiteSettingsForm';
import { TournamentAddEventForm } from '../TournamentAddEventForm/TournamentAddEventForm';
import { TournamentDefaultGroupsForm } from '../TournamentDefaultGroupsForms/TournamentDefaultGroupsForm';
import { TournamentEventsGroupForm } from '../TournamentEventsGroupForm/TournamentEventsGroupsForm';
import { TournamentEditTournamentTVForm } from '../TournamentEditTournamentTVForm/TournamentEditTournamentTVForm';
import { ExtendedTournamentScheduleReportForm } from '../Reports/ExtendedTournamentScheduleReportForm/ExtendedTournamentScheduleReportForm';
import { TournamentTeamMembersReportForm } from '../Reports/TournamentTeamMembersReportForm/TournamentTeamMembersReportForm';
import { TournamentParticipationConfirmationsReportForm } from '../Reports/TournamentParticipationConfirmationsReportForm/TournamentParticipationConfirmationsReportForm';
import { TournamentStartListReportForm } from '../Reports/TournamentStartListReportForm/TournamentStartListReportForm';
import { UnionMemberSchoolsStatisticsReportForm } from '../Reports/UnionMemberSchoolsStatisticsReportForm/UnionMemberSchoolsStatisticsReportForm';
import { UnionMemberSchoolsTournamentsReportForm } from '../Reports/UnionMemberSchoolsTournamentsReportForm/UnionMemberSchoolsTournamentsReportForm';
import { UnionMemberSchoolsTournamentsAsPartOfUnionReportForm } from '../Reports/UnionMemberSchoolsTournamentsAsPartOfUnionReportForm/UnionMemberSchoolsTournamentsAsPartOfUnionReportForm';
import { TournamentPlayersReportForm } from '../Reports/TournamentPlayersReportForm/TournamentPlayersReportForm';
import { TournamentScoreCardsReportForm } from '../Reports/TournamentScoreCardsReportForm/TournamentScoreCardsReportForm';
import { TournamentResultsIndividualReportForm } from '../Reports/TournamentResultsIndividualReportForm/TournamentResultsIndividualReportForm';
import { TournamentSchoolsReportForm } from '../Reports/TournamentSchoolsReportForm/TournamentSchoolsReportForm';
import { HighLevelTournamentSchoolAdminsReportForm } from '../Reports/HighLevelTournamentSchoolAdminsReportForm/HighLevelTournamentSchoolAdminsReportForm';
import '../Tournaments.css';
import { UnionTournamentsListHeader } from '../UnionTournamentsListHeader';
import { UnionTournamentListPageHelp } from '../UnionTournamentListPageHelp';
import {
  TournamentHighlightedCell,
  TournamentNameCell,
  TournamentPlacesCell,
  TournamentPublishedCell,
  TournamentStartCell,
  TournamentTagsCell,
  TournamentWaitingCell
} from '../TournamentListCells';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Tournament',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    cell: TournamentNameCell
  },
  {
    text: 'Season',
    field: 'season',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getSeason
  },
  {
    text: 'Sport',
    field: 'sportId',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    filterControl: 'select',
    accessor: ['sport', 'name']
  },
  {
    text: 'Starts',
    field: 'startTime',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    cell: TournamentStartCell
  },
  {
    text: 'End',
    field: 'endTime',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getEndTime
  },
  {
    text: 'Places',
    field: 'spaces',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: TournamentPlacesCell
  },
  {
    text: 'Waiting',
    field: 'wlValue',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: TournamentWaitingCell
  },
  {
    text: 'Published',
    field: 'isPublishOnTheWebsite',
    isSort: true,
    type: FILTER_TYPE.SELECT,
    cell: TournamentPublishedCell
  },
  {
    text: 'Highlighted',
    field: 'isPromoteTournament',
    isSort: true,
    type: FILTER_TYPE.SELECT,
    cell: TournamentHighlightedCell
  },
  {
    text: 'Tags',
    field: 'tournamentTag',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    cell: TournamentTagsCell
  }
];

interface State {
  items: Tournament[];
  currentPage: number;
  selectedItems: Tournament[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filters: any;
  isDataFiltered: boolean;
  isLoading: boolean;
  total: number;
  totalAll: number;
  basePath: string;
  isSelectAllChecked: boolean;
  tournamentTags: any[];
  isEditableAutoEnrollment: boolean;
  isEditablePublicSiteSettings: boolean;
  isInformationModalShow: boolean;
  isRemoveExistingEventsModalShow: boolean;
  isAddTournamentToChampionshipModalOpen: boolean;
  isRemoveTournamentToChampionshipModalOpen: boolean;
  isAddEventModalOpen: boolean;
  isAddEventDirty: boolean;
  isDiscardAddEventOpen: boolean;
  isDefaultGroupsModalOpen: boolean;
  isCreateEventsForGroupModalOpen: boolean;
  isWarningAboutDeletingEventsModalOpen: boolean;
  isEditableTournamentTVSettings: boolean;
  isDeleteTournamentConfirmationModalOpen: boolean;
  deleteTournamentBlockers: Array<{ name: string; blockers: string[] }>;

  currentTabIndex: number;
  eligibleSchools: EligibleSchool[];
  confirmationRequests: TournamentConfirmationRequestMessage[];
  tournamentEvents: any[];
  admins: any[];
  enrollmentLogs: any[];
  championships: Championship[];
  teams: any[];
  schoolUnions: any[];
  participants: any[];
  eventsForGroupFormSubmitData: any;
  modalTitle: string;
  modalText: string;
  errorMessage: string;

  isErrorModalOpen: boolean;
  isTournamentTagModalOpen: boolean;
  isTournamentTagDeleteModalOpen: boolean;
  isExtendedTournamentScheduleReportModalOpen: boolean; //011;
  isTournamentTeamMembersReportModalOpen: boolean; //033
  isTournamentParticipationConfirmationsReportModalOpen: boolean; //012
  isTournamentStartListReportModalOpen: boolean; //034
  isUnionMemberSchoolsStatisticsReportModalOpen: boolean; //018
  isUnionMemberSchoolsTournamentsReportModalOpen: boolean; //038
  isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen: boolean; //039
  isTournamentPlayersReportModalOpen: boolean; //040
  isTournamentScoreCardsReportModalOpen: boolean; //042
  isTournamentResultsIndividualReportModalOpen: boolean; //036
  isTournamentSchoolsReportModalOpen: boolean; //046
  isHighLevelTournamentSchoolAdminsReportModalOpen: boolean; //063
  isReportsSelectionModalOpen: boolean;

  selectedTournamentTagId: string;

  isAssignEventNumbersModalOpen: boolean;
  assignStartFrom: string;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class TournamentsUpcoming extends React.Component<Props, State> {
  private additionalItemsPromise?: Promise<boolean>;
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filters: {},
      isDataFiltered: false,
      isLoading: false,
      total: 0,
      totalAll: 0,
      basePath: '',
      isSelectAllChecked: false,
      tournamentTags: [],
      isEditableAutoEnrollment: false,
      isEditablePublicSiteSettings: false,
      isInformationModalShow: false,
      isRemoveExistingEventsModalShow: false,
      isAddTournamentToChampionshipModalOpen: false,
      isRemoveTournamentToChampionshipModalOpen: false,
      isAddEventModalOpen: false,
      isAddEventDirty: false,
      isDiscardAddEventOpen: false,
      isDefaultGroupsModalOpen: false,
      isCreateEventsForGroupModalOpen: false,
      isWarningAboutDeletingEventsModalOpen: false,
      isEditableTournamentTVSettings: false,
      isDeleteTournamentConfirmationModalOpen: false,
      deleteTournamentBlockers: [],
      isExtendedTournamentScheduleReportModalOpen: false,
      isTournamentTeamMembersReportModalOpen: false,
      isTournamentParticipationConfirmationsReportModalOpen: false,
      isTournamentStartListReportModalOpen: false,
      isUnionMemberSchoolsStatisticsReportModalOpen: false,
      isUnionMemberSchoolsTournamentsReportModalOpen: false,
      isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen: false,
      isTournamentPlayersReportModalOpen: false,
      isTournamentScoreCardsReportModalOpen: false,
      isTournamentResultsIndividualReportModalOpen: false,
      isTournamentSchoolsReportModalOpen: false,
      isHighLevelTournamentSchoolAdminsReportModalOpen: false,
      isReportsSelectionModalOpen: false,
      currentTabIndex: 0,
      eligibleSchools: [],
      confirmationRequests: [],
      tournamentEvents: [],
      admins: [],
      enrollmentLogs: [],
      championships: [],
      teams: [],
      schoolUnions: [],
      participants: [],
      eventsForGroupFormSubmitData: undefined,
      modalTitle: '',
      errorMessage: '',
      isErrorModalOpen: false,
      isTournamentTagModalOpen: false,
      isTournamentTagDeleteModalOpen: false,
      modalText: '',
      selectedTournamentTagId: '',
      isAssignEventNumbersModalOpen: false,
      assignStartFrom: '1'
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems(nextProps);
    }
  }

  setAdditionalItems() {
    if (this.additionalItemsPromise) return this.additionalItemsPromise;
    const { user } = this.props;

    this.additionalItemsPromise = Promise.all([
      getAllChampionships(user),
      getTournamentTags(user),
      getAllSchoolUnionSchools(user, { kind: { $in: [KIND.SCHOOL_UNION] } })
    ])
      .then(([championships, tournamentTags, schoolUnions]) => {
        this.setState({
          championships: championships,
          tournamentTags: tournamentTags,
          schoolUnions: schoolUnions
        });

        return true;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        this.additionalItemsPromise = undefined;
        return false;
      });
    return this.additionalItemsPromise;
  }

  setItems(props = this.props) {
    const { history, user, location } = props;

    const search = parse(location.search || '');
    const unansweredConfirmationRequests = search.confirmationReplies === 'unanswered';
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;
    const lastSelectedFilters = propz.get(history, ['location', 'state', 'filters']);
    const isExistSelectedFilters = typeof lastSelectedFilters !== 'undefined';
    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = isExistSelectedFilters ? lastSelectedFilters : getFilters2(COLUMNS, search);
    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getItemsPromise = getUpcomingTournaments(user, serverQueryFilter, unansweredConfirmationRequests);
    const getItemsCountPromise = getUpcomingTournamentsCount(user, where, unansweredConfirmationRequests);
    const getAllItemsCountPromise = getUpcomingTournamentsCount(user);

    return Promise.all([getItemsCountPromise, getAllItemsCountPromise, getItemsPromise]).then(
      ([countObj, allCountObj, items]) => {
        const tournamentId = propz.get(location, ['state', 'tournamentId']);
        if (typeof tournamentId !== 'undefined') {
          const tournament = items.find(item => item.id === tournamentId);

          this.setState({
            currentPage: page,
            sortDirection: sortDirection,
            sortColumnsName: sortColumnsName,
            isShowFilter: isShowFilter,
            isDataFiltered: isDataFiltered,
            filters: filters,
            items: items,
            total: countObj.count,
            totalAll: allCountObj.count,
            basePath: history.location.pathname,
            isLoading: false,
            selectedItems: typeof tournament !== 'undefined' ? [tournament] : []
          });

          const state = { ...(history.location.state as any) };
          delete state.tournamentId;
          history.replace({ ...history.location, state });
        } else {
          this.setState({
            currentPage: page,
            sortDirection: sortDirection,
            sortColumnsName: sortColumnsName,
            isShowFilter: isShowFilter,
            isDataFiltered: isDataFiltered,
            filters: filters,
            items: items,
            total: countObj.count,
            totalAll: allCountObj.count,
            basePath: history.location.pathname,
            isLoading: false
          });
        }

        return true;
      }
    );
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];
    const { filters, sortColumnsName, sortDirection } = this.state;

    if (parse(this.props.location.search || '').confirmationReplies === 'unanswered') {
      search.push('confirmationReplies=unanswered');
    }

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onItemSelect = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
      currentTabIndex: 0
    });
  };

  onItemClick = (index: number): void => {
    const tournament = this.state.items[index];
    if (tournament) this.onManageTournamentClick(tournament);
  };

  onManageTournamentClick = (tournament: Tournament): void => {
    const { basePath, currentPage, filters } = this.state;
    const { search } = this.props.location;
    this.props.history.push({
      pathname: '/tournaments/manage',
      search: `tournament=${tournament.id}`,
      state: {
        search,
        prevPath: basePath,
        tournamentListState: { currentPage, filters }
      }
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });

    getAllUpcomingTournaments(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (options && options.modernRange) {
      nextFilters = {
        ...nextFilters,
        [filterField]: options.modernRange
      };
    } else if (options && options.modernMultiValue) {
      nextFilters = {
        ...nextFilters,
        [filterField]: Array.isArray(filterValue) ? filterValue : []
      };
    } else if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;

        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter ? filter.type : FILTER_TYPE.NONE;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const selectOptions = event.target.options;
        const value: string[] = [];

        for (let i = 0; i < selectOptions.length; i++) {
          if (selectOptions[i].selected) {
            value.push(selectOptions[i].value);
          }
        }

        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: {}
    });

    const { history } = this.props;
    const { basePath } = this.state;

    history.push({
      pathname: basePath,
      search: ''
    });
  };

  onClearIndividualFilter = (filterField: string): void => {
    const { filters, sortDirection, sortColumnsName, basePath } = this.state;
    const nextFilters = { ...filters };
    delete nextFilters[filterField];

    const search: string[] = [];
    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }
    if (isFilterExist2(nextFilters)) {
      search.push(getSearchFilter(nextFilters));
    }

    this.setState({
      filters: nextFilters,
      selectedItems: [],
      isSelectAllChecked: false
    });

    this.props.history.push({
      pathname: basePath,
      search: search.join('&')
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    if (!isShowFilter) this.setAdditionalItems();
    this.setState({ isShowFilter: !isShowFilter });
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false }, () => this.setItems());
  };

  isOneItemSelected(): boolean {
    const selectedItems = this.state.selectedItems;
    return selectedItems.length === 1;
  }

  onDeleteTournamentClick = () => {
    const { selectedItems } = this.state;
    const user = this.props.user;
    this.setState({ isLoading: true });
    Promise.all(selectedItems.map(item => deleteTournament(user, item.id)))
      .then(() => {
        this.setState({
          selectedItems: [],
          isSelectAllChecked: false,
          isDeleteTournamentConfirmationModalOpen: false,
          deleteTournamentBlockers: []
        });
        this.setItems();
      })
      .catch(error => {
        this.setState({ isLoading: false });
        console.error('Failed to delete tournament:', error);
        this.openDeleteTournamentConfirmationModal();
      });
  };

  renderDeleteTournamentConfirmationModal(): React.ReactNode {
    const { isDeleteTournamentConfirmationModalOpen, selectedItems, deleteTournamentBlockers } = this.state;
    const blockerLabels: { [key: string]: string } = {
      participants: 'Schools or participants are already enrolled',
      teams: 'Teams have already been created',
      events: 'Events or fixtures have already been created',
      invites: 'Tournament invitations have already been sent',
      confirmationRequests: 'Tournament confirmation requests already exist',
      checkFailed: 'We could not verify whether this tournament can be safely deleted. Please try again.'
    };
    const isBlocked = deleteTournamentBlockers.length > 0;

    return (
      <SimpleModal
        isOpen={isDeleteTournamentConfirmationModalOpen}
        title={
          isBlocked
            ? 'Tournament cannot be deleted'
            : selectedItems.length === 1
            ? 'Delete tournament?'
            : 'Delete tournaments?'
        }
        buttonCancelText={isBlocked ? 'Close' : 'Cancel'}
        buttonText={isBlocked ? undefined : selectedItems.length === 1 ? 'Delete tournament' : 'Delete tournaments'}
        onButtonClick={isBlocked ? undefined : this.onDeleteTournamentClick}
        onCloseClick={this.closeDeleteTournamentConfirmationModal}
        customClass="unionTournamentDeleteModal"
        dialogStyle={{ maxWidth: 520 }}
        isBodyBold={false}
      >
        <div className="unionTournamentDeleteModal__body">
          <div className="unionTournamentDeleteModal__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 8v5" />
              <path d="M12 17h.01" />
              <path d="M10.3 3.9 2.4 17.6A2 2 0 0 0 4.1 20h15.8a2 2 0 0 0 1.7-2.4L13.7 3.9a2 2 0 0 0-3.4 0Z" />
            </svg>
          </div>
          <div className="unionTournamentDeleteModal__copy">
            {isBlocked ? (
              <>
                <strong>
                  {deleteTournamentBlockers.length === 1
                    ? 'This tournament cannot be deleted for the following reasons:'
                    : 'Some selected tournaments cannot be deleted:'}
                </strong>
                <p>
                  A tournament can only be deleted when it has no enrolled participants, teams, events, invitations or
                  confirmation requests.
                </p>
                {deleteTournamentBlockers.map(item => (
                  <div key={item.name} className="unionTournamentDeleteModal__blocker">
                    <b>{item.name}</b>
                    <ul>
                      {item.blockers.map(blocker => (
                        <li key={blocker}>{blockerLabels[blocker] || blocker}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </>
            ) : (
              <>
                <strong>
                  {selectedItems.length === 1 ? selectedItems[0].name : `${selectedItems.length} selected tournaments`}
                </strong>
                <p>This action permanently deletes the selected tournament data and cannot be undone.</p>
              </>
            )}
          </div>
        </div>
      </SimpleModal>
    );
  }

  openDeleteTournamentConfirmationModal = async () => {
    const { selectedItems } = this.state;
    if (!selectedItems.length) return;
    this.setState({ isLoading: true });
    try {
      const checks = await Promise.all(
        selectedItems.map(async tournament => {
          try {
            return {
              tournament,
              check: await getTournamentDeletionCheck(this.props.user, tournament.id)
            };
          } catch (error) {
            console.error(`Failed to check whether tournament ${tournament.id} can be deleted:`, error);
            return {
              tournament,
              check: { canDelete: false, blockers: ['checkFailed'] }
            };
          }
        })
      );
      this.setState({
        isLoading: false,
        isDeleteTournamentConfirmationModalOpen: true,
        deleteTournamentBlockers: checks
          .filter(item => !item.check.canDelete)
          .map(item => ({ name: item.tournament.name, blockers: item.check.blockers }))
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        isDeleteTournamentConfirmationModalOpen: true,
        deleteTournamentBlockers: selectedItems.map(item => ({ name: item.name, blockers: ['checkFailed'] }))
      });
      console.error('Failed to check whether tournaments can be deleted:', error);
    }
  };

  closeDeleteTournamentConfirmationModal = () => {
    this.setState({
      isDeleteTournamentConfirmationModalOpen: false,
      deleteTournamentBlockers: []
    });
  };

  onAddTournamentToChampionshipClick = () => {
    this.setState({
      isAddTournamentToChampionshipModalOpen: true
    });
  };

  onRemoveTournamentToChampionshipClick = () => {
    this.setState({
      isRemoveTournamentToChampionshipModalOpen: true
    });
  };

  openAssignEventNumbersModal = (): void => {
    this.setState({ isAssignEventNumbersModalOpen: true, assignStartFrom: '1' });
  };

  closeAssignEventNumbersModal = (): void => {
    this.setState({ isAssignEventNumbersModalOpen: false });
  };

  onAssignStartFromChange = (e): void => {
    this.setState({ assignStartFrom: e.target.value });
  };

  onAssignEventNumbersSubmit = (): void => {
    const { user } = this.props;
    const { selectedItems, assignStartFrom } = this.state;
    const tournament = selectedItems[0];
    if (!tournament) return;

    const startNum = Number(assignStartFrom);
    if (!Number.isInteger(startNum)) {
      this.setState({
        errorMessage: 'Please enter a whole number (e.g., 1, 101, 10001).',
        isErrorModalOpen: true
      });
      return;
    }

    this.setState({ isLoading: true });

    assignTournamentEventNumbers(user, tournament.id, startNum)
      .then(({ updated, startFrom, endAt }) => {
        this.setState({
          isInformationModalShow: true,
          modalTitle: 'Event numbers assigned',
          modalText: `Updated ${updated} events: ${startFrom} → ${endAt}`,
          isAssignEventNumbersModalOpen: false
        });
        // Refresh events tab if open
        return getAllTournamentEvents(user, tournament.id).then(events => {
          this.setState({ tournamentEvents: events });
        });
      })
      .catch(err => {
        const msg = err?.response?.data?.details?.text || err?.message || 'Failed to assign event numbers.';
        this.setState({
          errorMessage: msg,
          isErrorModalOpen: true
        });
      })
      .then(() => {
        this.setState({ isLoading: false });
      });
  };

  onClickDownloadCSV = () => {
    const { user } = this.props;
    const tournamentId = this.state.selectedItems[0].id;

    getCsvListTournamentStudents(user, tournamentId)
      .then(csv => {
        this.downloadCSV(csv);
      })
      .catch(error => {
        console.error(error.response.data.details.text);
      });
  };

  downloadCSV = (csv): void => {
    try {
      // copy-paste from old frontend
      /*global Blob:true*/
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (window.navigator.msSaveBlob) {
        // IE 10+
        window.navigator.msSaveBlob(blob, 'file.csv');
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          /*global URL:true*/
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', 'file.csv');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  saveBlobFile = (blob: Blob, filename: string): void => {
    try {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'meet-pack.zip';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  };

  onDownloadMeetPackClick = (): void => {
    const { user } = this.props;
    const tournament = this.state.selectedItems[0];
    if (!tournament) return;

    this.setState({ isLoading: true });

    downloadTournamentMeetPack(user, tournament.id)
      .then(({ blob, filename }) => {
        this.saveBlobFile(blob, filename);
      })
      .catch(err => {
        const msg = err?.response?.data?.details?.text || err?.message || "Couldn't download the meet pack.";
        console.error(err);
        this.setState({ errorMessage: msg, isErrorModalOpen: true });
      })
      .then(() => {
        // “finally” equivalent
        this.setState({ isLoading: false });
      });
  };

  getSchoolsWaitingListCount = eligibleSchools => {
    const schoolsWaitingList = eligibleSchools.filter(school => {
      const isNoParticipant = !school.isParticipant;
      const inviteStatusAccepted =
        propz.get(school, ['invite', 'status'], INVITE_STATUS.NOT_READY) === INVITE_STATUS.ACCEPTED;
      return isNoParticipant && inviteStatusAccepted;
    });
    return schoolsWaitingList.length;
  };

  hasSchoolUnionParticipant = (): boolean => {
    const { eligibleSchools, schoolUnions } = this.state;
    const unionIds = new Set(schoolUnions.map(u => u.id));
    return eligibleSchools.some(school => school.isParticipant && unionIds.has(school.id));
  };

  onShowWaitingListButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/waitingList`,
      search: `tournament=${tournamentId}`,
      state: { search, prevPath: basePath }
    });
  };

  onTournamentTagAssignClick = (): void => {
    this.setState({
      isTournamentTagModalOpen: true
    });
  };

  onTournamentTagDeleteClick = (): void => {
    this.setState({
      isTournamentTagDeleteModalOpen: true
    });
  };

  onTournamentTagChange = (event): void => {
    const value = event.target.value;

    this.setState({
      selectedTournamentTagId: value
    });
  };

  onTournamentTagAssignModalCloseClick = (): void => {
    this.setState({
      isTournamentTagModalOpen: false,
      selectedTournamentTagId: ''
    });
  };

  onTournamentTagSaveClick = (selectedTagIds: string[] = []): void => {
    const tournamentTagIds = selectedTagIds.length
      ? selectedTagIds
      : this.state.selectedTournamentTagId
      ? [this.state.selectedTournamentTagId]
      : [];
    const user = this.props.user;

    this.setState({
      isLoading: true
    });

    if (!tournamentTagIds.length) {
      this.setState({
        isTournamentTagModalOpen: false,
        selectedTournamentTagId: '',
        isLoading: false
      });
      console.error('Can not assign tournament tags without tag ids');
    } else {
      const selectedItems = this.state.selectedItems;
      Promise.all(
        selectedItems.reduce<any[]>((requests, selectedItem) => {
          tournamentTagIds.forEach(tournamentTagId => {
            const isAlreadyAssigned = (selectedItem.tournamentTags || []).some(tag => tag.id === tournamentTagId);
            if (!isAlreadyAssigned) {
              requests.push(assignTournamentTag(user, { tournamentTagId }, selectedItem.id));
            }
          });
          return requests;
        }, [])
      ).then(items => {
        this.setState({
          isTournamentTagModalOpen: false,
          selectedTournamentTagId: '',
          selectedItems: []
        });
        this.setItems();
      });
    }
  };

  renderTournamentTagAssignModal(): React.ReactNode {
    const { tournamentTags, selectedTournamentTagId, isTournamentTagModalOpen } = this.state;

    return (
      <TournamentTagAssignModal
        modalTitle={'Assign Tournament Tag'}
        tournamentTags={tournamentTags}
        selectedTournamentTagId={selectedTournamentTagId}
        selectedTournaments={this.state.selectedItems}
        onTournamentTagChange={this.onTournamentTagChange}
        onCloseClick={this.onTournamentTagAssignModalCloseClick}
        isOpen={isTournamentTagModalOpen}
        onSaveClick={this.onTournamentTagSaveClick}
      />
    );
  }

  renderAssignEventNumbersModal(): React.ReactNode {
    const { isAssignEventNumbersModalOpen, assignStartFrom } = this.state;

    return (
      <SimpleModal
        isOpen={isAssignEventNumbersModalOpen}
        title={'Assign event numbers'}
        body={
          <div>
            <label className="d-block mb-2">Starting number</label>
            <input
              type="number"
              className="form-control"
              value={assignStartFrom}
              onChange={this.onAssignStartFromChange}
              placeholder="e.g. 1 or 101 or 10001"
            />
            <small className="text-muted d-block mt-2">
              Events will be numbered sequentially (e.g. 101, 102, 103) in start-time order.
            </small>
          </div>
        }
        buttonText="Assign"
        onButtonClick={this.onAssignEventNumbersSubmit}
        onCloseClick={this.closeAssignEventNumbersModal}
        buttonCancelText="Cancel"
      />
    );
  }

  getTournamentTags(): TournamentTag[] {
    const { selectedItems, items } = this.state;

    const tournamentTags = Lazy(selectedItems)
      .map(selectedItem => {
        const selectedTournamentId = selectedItem.id;
        const tournament = items.find(tournamentState => tournamentState.id === selectedTournamentId);

        if (tournament && tournament.tournamentTags) {
          return tournament.tournamentTags;
        } else {
          return [];
        }
      })
      .filter(tournamentTagList => tournamentTagList.length > 0)
      .flatten()
      .uniq('id')
      .toArray();

    return tournamentTags;
  }

  onTournamentTagDeleteModalCloseClick = (): void => {
    this.setState({
      isTournamentTagDeleteModalOpen: false,
      selectedTournamentTagId: ''
    });
  };

  onTournamentTagDelete = (selectedTagIds: string[] = []): void => {
    const { selectedTournamentTagId, selectedItems } = this.state;
    const { user } = this.props;
    const tournamentTagIds = selectedTagIds.length
      ? selectedTagIds
      : selectedTournamentTagId
      ? [selectedTournamentTagId]
      : [];

    if (!tournamentTagIds.length) {
      console.error('Cannot remove tournament tags because no tag IDs are selected.');
      this.setState({
        isTournamentTagDeleteModalOpen: false,
        selectedTournamentTagId: ''
      });
      return;
    }

    this.setState({ isLoading: true });

    const deletePromises = selectedItems.reduce<any[]>((requests, tournament) => {
      tournamentTagIds.forEach(tournamentTagId => {
        const isAssigned = (tournament.tournamentTags || []).some(tag => tag.id === tournamentTagId);
        if (isAssigned) {
          requests.push(deleteTournamentTagByTournament(user, tournament.id, tournamentTagId));
        }
      });
      return requests;
    }, []);

    Promise.all(deletePromises)
      .then(() => {
        const updatedTournaments = selectedItems.map(tournament => {
          const tournamentTags = tournament.tournamentTags.filter(
            tournamentTag => !tournamentTagIds.includes(tournamentTag.id)
          );
          return { ...tournament, tournamentTags };
        });

        this.setState({
          selectedItems: updatedTournaments,
          isTournamentTagDeleteModalOpen: false,
          selectedTournamentTagId: '',
          isSelectAllChecked: false,
          isLoading: false
        });

        this.setItems();
      })
      .catch(error => {
        console.error('Failed to delete tournament tag:', error);
        this.setState({
          isTournamentTagDeleteModalOpen: false,
          isLoading: false
        });
      });
  };

  renderTournamentTagDeleteModal(): React.ReactNode {
    const { selectedTournamentTagId, isTournamentTagDeleteModalOpen } = this.state;

    return (
      <TournamentTagDeleteModal
        modalTitle={'Delete Tournament Tag'}
        tournamentTags={this.getTournamentTags()}
        selectedTournamentTagId={selectedTournamentTagId}
        selectedTournaments={this.state.selectedItems}
        onTournamentTagChange={this.onTournamentTagChange}
        onCloseClick={this.onTournamentTagDeleteModalCloseClick}
        isOpen={isTournamentTagDeleteModalOpen}
        onDeleteClick={this.onTournamentTagDelete}
      />
    );
  }

  renderGrid() {
    const {
      isLoading,
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total,
      totalAll,
      tournamentTags
    } = this.state;

    const isAllYesPromoteTournamentSelectedItems = selectedItems.every(item => item.isPromoteTournament);
    const isAllNoPromoteTournamentSelectedItems = selectedItems.every(item => !item.isPromoteTournament);
    const isAllYesPublishOnTheWebsiteSelectedItems = selectedItems.every(item => item.isPublishOnTheWebsite);
    const isAllNoPublishOnTheWebsiteSelectedItems = selectedItems.every(item => !item.isPublishOnTheWebsite);

    const visibleActionItems: ActionItem[] = [
      selectedItems.length === 1 && {
        itemText: 'Edit',
        onItemClick: this.onEditTournamentClick,
        isActive: true
      },
      selectedItems.length === 1 && {
        itemText: 'Create like this',
        onItemClick: this.onCopyTournamentClick,
        isActive: true
      },
      selectedItems.length > 0 &&
        isAllNoPublishOnTheWebsiteSelectedItems && {
          itemText: 'Publish',
          onItemClick: () => this.onEditTournament(true, 'isPublishOnTheWebsite'),
          isActive: true
        },
      selectedItems.length > 0 &&
        isAllYesPublishOnTheWebsiteSelectedItems && {
          itemText: 'Unpublish',
          onItemClick: () => this.onEditTournament(false, 'isPublishOnTheWebsite'),
          isActive: true
        },
      selectedItems.length > 0 &&
        isAllNoPromoteTournamentSelectedItems && {
          itemText: 'Highlight',
          onItemClick: () => this.onEditTournament(true, 'isPromoteTournament'),
          isActive: true
        },
      selectedItems.length > 0 &&
        isAllYesPromoteTournamentSelectedItems && {
          itemText: 'Unhighlight',
          onItemClick: () => this.onEditTournament(false, 'isPromoteTournament'),
          isActive: true
        },
      selectedItems.length > 0 && {
        itemText: 'Add tags',
        onItemClick: this.onTournamentTagAssignClick,
        isActive: true
      },
      selectedItems.length > 0 && {
        itemText: 'Remove tags',
        onItemClick: this.onTournamentTagDeleteClick,
        isActive: true
      },
      selectedItems.length > 0 && {
        itemText: 'Delete',
        onItemClick: this.openDeleteTournamentConfirmationModal,
        isActive: true,
        isDanger: true
      }
    ].filter(Boolean) as ActionItem[];

    const filterOptions = {
      season: getSelectOptionForUpcomingTournamentsSeason(items),
      sportId: Array.from(
        new Map(
          items
            .filter(item => item.sportId && item.sport)
            .map(item => [item.sportId, { value: item.sportId, text: item.sport.name }])
        ).values()
      ),
      isPublishOnTheWebsite: getSelectOptionForBooleanQuestion(),
      isPromoteTournament: getSelectOptionForBooleanQuestion(),
      tournamentTag: getSelectOptionForTournamentTag(tournamentTags).map(option => ({
        ...option,
        color: propz.get(
          tournamentTags.find(tag => String(tag.id) === String(option.value)),
          ['tagColor'],
          '#227ebd'
        )
      }))
    };

    const todayMidnight = new Date(new Date().setHours(0, 0, 1));

    return (
      <div className="unionTournamentsModern unionTournamentsListShell">
        <UnionTournamentListPageHelp
          kind="upcoming"
          isLoading={isLoading}
          total={total}
          currentPage={currentPage}
          filters={filters}
          selectedItems={selectedItems}
          onAddTournament={this.onCreateTournamentClick}
          onOpenFilters={() => this.onTableFilterClick({ preventDefault: () => undefined })}
          onClearFilters={this.onClearFilterClick}
          onManageTournament={this.onManageTournamentClick}
        />
        <UnionTournamentsListHeader
          user={this.props.user}
          history={this.props.history}
          activeSection="upcoming"
          onAddTournament={this.onCreateTournamentClick}
        />
        <div className="unionTournamentsListCard" data-help-anchor="union-tournaments-list">
          <Grid2
            user={this.props.user}
            dataItems={items}
            filters={filters}
            currentPage={currentPage}
            total={total}
            isSelectAllChecked={isSelectAllChecked}
            isDataFiltered={isDataFiltered}
            emptyIcon={faTrophy}
            emptyText="No upcoming tournaments"
            emptyHint="Upcoming tournaments will appear here when they are created."
            emptyFilteredText="No upcoming tournaments match your filters"
            emptyFilteredHint="Try changing or clearing the search and filters to see more tournaments."
            sortDirection={sortDirection}
            sortColumnsName={sortColumnsName}
            isShowFilter={isShowFilter}
            dataItemsSelected={selectedItems}
            columns={COLUMNS}
            actionItems={visibleActionItems}
            isCSV={false}
            options={filterOptions}
            onItemClick={this.onItemClick}
            onItemSelect={this.onItemSelect}
            onSortClick={this.onTableSortClick}
            onApplyFilterClick={this.onApplyFilterClick}
            onClearFilterClick={this.onClearFilterClick}
            onClearIndividualFilter={this.onClearIndividualFilter}
            onCancelFilterClick={this.onCancelFilterClick}
            onTableFilterChange={this.onTableFilterChange}
            onTableFilterClick={this.onTableFilterClick}
            setCurrentPageParams={this.setCurrentPageParams}
            onSelectAllClick={this.onSelectAllClick}
            onSelectAllOnPageClick={this.onSelectAllOnPageClick}
            onUnselectAllClick={this.onUnselectAllClick}
            filterMinDateInterval={todayMidnight}
            gridTitle={`${total} tournaments`}
            toolbarSearchField="name"
            toolbarSearchPlaceholder="Search tournaments..."
            onToolbarSearchClear={() => this.onClearIndividualFilter('name')}
            hiddenFilterFields={['name']}
            isActionsInline
            selectionActionsBelow
            defaultHiddenColumns={['sportId', 'endTime']}
            fixedColumnFields={['name']}
            filterOnlyFields={['sportId', 'endTime', 'isPublishOnTheWebsite', 'isPromoteTournament']}
            columnVisibilityKey="union-upcoming-tournaments"
            renderAdditionalOptions={() => (
              <button type="button" className="unionTournamentsReportsButton" onClick={this.openReportsSelectionModal}>
                Reports
              </button>
            )}
            stylizeCell={cell => {
              if (cell.column.field === 'wlValue' && cell.value === 'WL') {
                return 'orangeBold';
              }
              return '';
            }}
          />
        </div>
      </div>
    );
  }

  getSummaryTabs(): React.ReactNode {
    const {
      currentTabIndex,
      selectedItems,
      eligibleSchools,
      confirmationRequests,
      tournamentEvents,
      admins,
      enrollmentLogs,
      championships,
      teams
    } = this.state;

    const { user } = this.props;

    const tournament = selectedItems[0];

    const tabs = isTeamTournament(tournament) || isMiniTeamTournament(tournament)
      ? TEAM_TOURNAMENT_TABS
      : isIndividualTournament(tournament) ? INDIVIDUAL_TOURNAMENT_TABS : TOURNAMENT_TABS;
    const currentTab = tabs[currentTabIndex];
    const schoolsWaitingListCount = this.getSchoolsWaitingListCount(eligibleSchools);

    switch (currentTab) {
      case TABS.SUMMARY:
        return <TournamentSummary tournament={tournament} championships={championships} />;
      case TABS.PARTICIPANTS:
        return <TournamentParticipantsSummary tournament={tournament} />;
      case TABS.COMPETITORS:
        return <TournamentCompetitorsSummary user={user} tournamentId={tournament.id} />;
      case TABS.ELIGIBLE_SCHOOLS:
        return <TournamentEligibleSchoolsSummary tournament={tournament} eligibleSchools={eligibleSchools} />;
      case TABS.WAITING_LIST:
        return (
          <div className="tournamentSummaryBody">
            <div className="tournamentSummaryItem">
              <div className="tournamentSummaryItemLabel">Schools on waiting list</div>
              <div className="tournamentSummaryItemValue">{schoolsWaitingListCount}</div>
            </div>
          </div>
        );
      case TABS.CONFIRMATION_REQUESTS:
        return <TournamentConfirmationRequestsSummary messages={confirmationRequests} />;
      case TABS.TOURNAMENT_EVENTS:
        return <TournamentEventsSummary tournament={tournament} events={tournamentEvents} user={user}
          onNumbersAssigned={() => getAllTournamentEvents(user, tournament.id).then(events => this.setState({ tournamentEvents: events }))} />;
      case TABS.AUTO_ENROLLMENT:
        return (
          <TournamentAutoEnrollmentSummary tournament={tournament} schoolsWaitingListCount={schoolsWaitingListCount} />
        );
      case TABS.PUBLIC_SITE_SETTINGS:
        return <TournamentPublicSiteSettingsSummary tournament={tournament} user={user} />;
      case TABS.TOURNAMENT_TV:
        return <TournamentTVSummary tournament={tournament} />;
      case TABS.ENROLLMENT_LOG:
        return <TournamentEnrollmentLogsSummary enrollmentLogs={enrollmentLogs} tournament={tournament} />;
      case TABS.ADMINS:
        return <TournamentAdminsSummary admins={admins} />;
      case TABS.PITCHES:
        return <TournamentPitchesSummary tournament={tournament} />;
      case TABS.GROUPS:
        return <TournamentCustomGroupsSummary tournament={tournament} />;
      case TABS.TEAMS:
        return <TournamentTeamsSummary teams={teams} tournament={tournament} user={user} />;
      default:
        return <EmptyComponent />;
    }
  }

  onTabClick = (event, index: number) => {
    event.preventDefault();
    const { user } = this.props;
    const { selectedItems } = this.state;
    const tournament = selectedItems[0];

    const tabs = isTeamTournament(tournament) || isMiniTeamTournament(tournament)
      ? TEAM_TOURNAMENT_TABS
      : isIndividualTournament(tournament) ? INDIVIDUAL_TOURNAMENT_TABS : TOURNAMENT_TABS;
    const currentTab = tabs[index];
    const tournamentId = selectedItems[0].id;

    switch (currentTab) {
      case TABS.TEAMS:
        this.setState({
          isLoading: true
        });
        getAllSchoolUnionTournamentTeams(user, tournamentId).then(teams => {
          this.setState({
            currentTabIndex: index,
            teams: teams,
            isLoading: false
          });
        });
        break;

      case TABS.ELIGIBLE_SCHOOLS:
      case TABS.AUTO_ENROLLMENT:
      case TABS.WAITING_LIST:
        this.setState({
          isLoading: true
        });
        getAllTournamentEligibleSchools(user, tournamentId).then(schools => {
          this.setState({
            currentTabIndex: index,
            eligibleSchools: schools,
            isLoading: false
          });
        });
        break;

      case TABS.CONFIRMATION_REQUESTS:
        this.setState({
          isLoading: true
        });
        getAllTournamentConfirmationRequests(user, tournamentId).then(messages => {
          this.setState({
            currentTabIndex: index,
            confirmationRequests: messages,
            isLoading: false
          });
        });
        break;

      case TABS.TOURNAMENT_EVENTS:
        this.setState({
          isLoading: true
        });
        getAllTournamentEvents(user, tournamentId).then(events => {
          this.setState({
            currentTabIndex: index,
            tournamentEvents: events,
            isLoading: false
          });
        });
        break;

      case TABS.ENROLLMENT_LOG:
        this.setState({
          isLoading: true
        });
        const filter = {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP,
          order: 'createdAt DESC'
        };

        getTournamentEnrollmentLogs(user, tournamentId, filter).then(logs => {
          this.setState({
            currentTabIndex: index,
            enrollmentLogs: logs,
            isLoading: false
          });
        });
        break;

      case TABS.ADMINS:
        this.setState({
          isLoading: true
        });
        getAllTournamentAdmins(user, tournamentId).then(admins => {
          this.setState({
            currentTabIndex: index,
            admins: admins,
            isLoading: false
          });
        });
        break;

      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  onShowNotificationsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/notifications`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onEditParticipantsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/participants`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onManageAthleteSchoolsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/athleteSchools`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onEditEligibleSchoolsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/eligibleSchools`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onShowConfirmationRequestsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/confirmationRequests`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onEditAutoEnrollmentButtonClick = (): void => {
    this.setState({
      isEditableAutoEnrollment: true
    });
  };

  onCancelAutoEnrollmentButtonClick = (): void => {
    this.setState({
      isEditableAutoEnrollment: false
    });
  };

  onEditPublicSiteSettingsButtonClick = (): void => {
    this.setState({
      isEditablePublicSiteSettings: true
    });
  };

  onEditTournamentTVButtonClick = (): void => {
    this.setState({
      isEditableTournamentTVSettings: true
    });
  };

  onCancelTournamentTVButtonClick = (): void => {
    this.setState({
      isEditableTournamentTVSettings: false
    });
  };

  onCancelPublicSiteSettingsButtonClick = (): void => {
    this.setState({
      isEditablePublicSiteSettings: false
    });
  };

  onSubmitAutoEnrollmentForm = (data): void => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [tournament] = selectedItems;
    const tournamentId = tournament.id;

    const {
      autoEnrollmentSettings,
      maximumNumberTeamsOfSchool,
      isReadOnly,
      isAutoEnrollmentTeams,
      isEnableWaitingListWhenFull,
      isAutoEnrollmentToWaitingList,
      autoEnrollmentTeamsSettings: autoEnrollmentTeamsSettingsFromForm
    } = data;

    let dataToTransfer;

    if (isAutoEnrollmentTeams) {
      if (isIndividualTournament(tournament)) {
        const autoEnrollmentTeamsSettings: {
          age: number;
          gender: string;
          maximumNumberTeams: number;
        }[] = [];

        const tournamentAges = propz.get(tournament, ['ages'], []);

        tournamentAges.forEach((age, index) => {
          const maximumNumberTeams = index === 0 ? Number(autoEnrollmentSettings || 0) : 0;

          autoEnrollmentTeamsSettings.push({
            age: Number(age),
            gender: GENDER.MIXED,
            maximumNumberTeams
          });
        });

        dataToTransfer = {
          autoEnrollmentTeamsSettings,
          maximumNumberTeamsOfSchool,
          isReadOnly,
          isAutoEnrollmentTeams,
          isEnableWaitingListWhenFull,
          isAutoEnrollmentToWaitingList
        };
      } else {
        dataToTransfer = {
          autoEnrollmentTeamsSettings: autoEnrollmentTeamsSettingsFromForm,
          maximumNumberTeamsOfSchool,
          isReadOnly,
          isAutoEnrollmentTeams,
          isEnableWaitingListWhenFull,
          isAutoEnrollmentToWaitingList
        };
      }
    } else {
      dataToTransfer = {
        autoEnrollmentTeamsSettings: [],
        maximumNumberTeamsOfSchool,
        isReadOnly,
        isAutoEnrollmentTeams,
        isEnableWaitingListWhenFull,
        isAutoEnrollmentToWaitingList
      };
    }

    this.setState({
      isLoading: true
    });

    updateTournamentAutoEnrollment(user, dataToTransfer, tournamentId).then(
      ({
        isAutoEnrollmentTeams,
        isEnableWaitingListWhenFull,
        isAutoEnrollmentToWaitingList,
        autoEnrollmentTeamsSettings,
        maximumNumberTeamsOfSchool,
        isReadOnly
      }) => {
        const tournamentNext = {
          ...tournament,
          isAutoEnrollmentTeams,
          isEnableWaitingListWhenFull,
          isAutoEnrollmentToWaitingList,
          autoEnrollmentTeamsSettings,
          maximumNumberTeamsOfSchool,
          isReadOnly
        };

        this.setState({
          selectedItems: [tournamentNext],
          isEditableAutoEnrollment: false
        });
        this.setItems();
      }
    );
  };

  onSubmitTournamentSiteSettingsForm = (data): void => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const tournamentId = selectedItems[0].id;

    this.setState({
      isLoading: true
    });

    updateTournament(user, data, tournamentId).then(tournament => {
      this.setState({
        selectedItems: [tournament],
        isEditablePublicSiteSettings: false,
        isEditableTournamentTVSettings: false
      });
      this.setItems();
    });
  };

  informationModalClose = () => {
    this.setState({
      isInformationModalShow: false
    });
  };

  deleteGroupEvents = () => {
    const { user } = this.props;
    const { eventsForGroupFormSubmitData, tournamentEvents } = this.state;
    const events = tournamentEvents || [];

    this.setState({
      isLoading: true
    });

    const eventIds = events
      .filter(
        event =>
          event.tournamentGroupId === eventsForGroupFormSubmitData.tournamentGroupId &&
          event.ages.some(eventAge => eventAge === eventsForGroupFormSubmitData.age) &&
          event.gender === eventsForGroupFormSubmitData.gender
      )
      .map(event => event.id);

    Promise.all(eventIds.map(itemId => deleteEvent(user, itemId))).then(res => {
      this.setState({
        isRemoveExistingEventsModalShow: false
      });
      this.createGroupEvents();
    });
  };

  removeExistingEventsModalClose = () => {
    this.setState({
      isRemoveExistingEventsModalShow: false
    });
  };

  renderInformationModal(): React.ReactNode {
    const { isInformationModalShow, modalText, modalTitle } = this.state;

    return (
      <SimpleModal
        isOpen={isInformationModalShow}
        title={modalTitle}
        body={modalText}
        buttonText={'Ok'}
        onButtonClick={this.informationModalClose}
      />
    );
  }

  renderRemoveExistingEventsModalShowModal(): React.ReactNode {
    const { isRemoveExistingEventsModalShow, modalText, modalTitle } = this.state;

    return (
      <SimpleModal
        isOpen={isRemoveExistingEventsModalShow}
        title={modalTitle}
        body={modalText}
        buttonText={`Remove`}
        onButtonClick={this.deleteGroupEvents}
        onCloseClick={this.removeExistingEventsModalClose}
      />
    );
  }

  renderAutoEnrollmentModal() {
    const { isEditableAutoEnrollment, selectedItems } = this.state;
    const { user } = this.props;

    const [tournament] = selectedItems;

    return (
      <SimpleModal
        isOpen={isEditableAutoEnrollment}
        title={'Edit autoenrollment'}
        onCloseClick={this.onCancelAutoEnrollmentButtonClick}
        showFooter={false}
      >
        <TournamentAutoEnrollmentForm
          user={user}
          tournament={tournament}
          onCancel={this.onCancelAutoEnrollmentButtonClick}
          onSubmit={this.onSubmitAutoEnrollmentForm}
        />
      </SimpleModal>
    );
  }

  renderPublicSiteSettingsModal() {
    const { isEditablePublicSiteSettings, selectedItems } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal isOpen={isEditablePublicSiteSettings} title={'Edit tournament website settings'}>
        onCloseClick={this.onCancelPublicSiteSettingsButtonClick}
        <TournamentPublicSiteSettingsForm
          user={user}
          tournament={selectedItems[0]}
          onCancel={this.onCancelPublicSiteSettingsButtonClick}
          onSubmit={this.onSubmitTournamentSiteSettingsForm}
        />
      </SimpleModal>
    );
  }

  renderTournamentTVModal() {
    const { isEditableTournamentTVSettings, selectedItems } = this.state;
    const tournamentName = propz.get(selectedItems, ['0', 'name'], '');
    return (
      <SimpleModal isOpen={isEditableTournamentTVSettings} title={`Manage Tournament TV ${tournamentName}`}>
        <TournamentEditTournamentTVForm
          tournament={selectedItems[0]}
          onCancel={this.onCancelTournamentTVButtonClick}
          onSubmit={this.onSubmitTournamentSiteSettingsForm}
        />
      </SimpleModal>
    );
  }

  onShowPitchesButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location, user } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/pitches`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onEditCustomGroupsButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/customGroups`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onGridButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/grid`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onEditTeamsButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/teams`,
      search: `tournament=${tournamentId}`,
      state: { search, prevPath: basePath, sourceList: 'upcoming' }
    });
  };

  onEditEventsButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/events`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onAddDefaultGroupsButtonClick = (): void => {
    this.setState({
      isDefaultGroupsModalOpen: true
    });
  };

  onAddEventButtonClick = (): void => {
    const { user } = this.props;
    const { selectedItems } = this.state;

    const tournament = selectedItems[0];
    const { id } = tournament;

    this.setState({
      isLoading: true
    });

    getAllTournamentParticipants(user, id).then(participants => {
      this.setState({
        isAddEventModalOpen: true,
        isAddEventDirty: false,
        isDiscardAddEventOpen: false,
        isLoading: false,
        participants: participants
      });
    });
  };

  onCreateEventsForGroupButtonClick = (): void => {
    this.setState({
      isCreateEventsForGroupModalOpen: true
    });
  };

  onShowAdminsButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/admins`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onShowEnrollmentLogsButtonClick = () => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/logs`,
      search: `tournament=${tournamentId}`,
      state: { search: search, prevPath: basePath }
    });
  };

  onSubmitChampionshipClick = (data, championshipId): void => {
    const { user } = this.props;

    this.setState({
      isLoading: true
    });

    addOrRemoveTournamentsToChampionship(user, data, championshipId).then(() => {
      this.setState({
        isAddTournamentToChampionshipModalOpen: false,
        isRemoveTournamentToChampionshipModalOpen: false,
        isLoading: false
      });

      this.setAdditionalItems();
    });
  };

  onCloseAddTournamentToChampionshipModalClick = (): void => {
    this.setState({
      isAddTournamentToChampionshipModalOpen: false
    });
  };

  onCloseRemoveTournamentToChampionshipModalClick = (): void => {
    this.setState({
      isRemoveTournamentToChampionshipModalOpen: false
    });
  };

  onCreateTournamentClick = (): void => {
    const { totalAll, currentPage, filters, basePath } = this.state;
    const lastPage = getPagesCount(totalAll + 1, LIMIT);

    this.props.history.push({
      pathname: `/tournaments/tournamentView`,
      state: {
        currentTournamentPage: currentPage,
        lastTournamentPage: lastPage,
        filters,
        prevPath: basePath
      }
    });
  };

  onEditTournamentClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;
    const { currentPage, filters, basePath } = this.state;

    this.props.history.push({
      pathname: `/tournaments/tournamentView`,
      search: `tournament=${tournamentId}&mode=${MODE_TYPE.EDIT}`,
      state: {
        currentTournamentPage: currentPage,
        filters,
        prevPath: basePath
      }
    });
  };

  onCopyTournamentClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;
    const { totalAll, currentPage, filters, basePath } = this.state;
    const lastPage = getPagesCount(totalAll + 1, LIMIT);

    this.props.history.push({
      pathname: `/tournaments/tournamentView`,
      state: {
        currentTournamentPage: currentPage,
        lastTournamentPage: lastPage,
        filters,
        prevPath: basePath
      },
      search: `tournament=${tournamentId}&mode=${MODE_TYPE.COPY}`
    });
  };

  onEditTournament = (value, field) => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isLoading: true
    });

    Promise.all(
      selectedItems.map(tournament => {
        const dataCopy = { [field]: value };
        return updateTournament(user, dataCopy, tournament.id);
      })
    )
      .then(res => {
        this.setState({
          selectedItems: []
        });
        this.setItems();
      })
      .catch(error => {
        console.error(error.response.data.details.text);
      });
  };

  renderTournamentAddToChampionshipModal(): React.ReactNode {
    const { user } = this.props;
    const { selectedItems, isAddTournamentToChampionshipModalOpen, championships } = this.state;
    const tournaments = selectedItems;
    const isOnlySameSport = selectedItems.every((selectedItem, i, list) => selectedItem.sportId === list[0].sportId);

    const isOpen = isAddTournamentToChampionshipModalOpen && isOnlySameSport;
    const onlyUnusedChampionships = championships.filter(championship => {
      return (
        championship.tournamentIds.every(championshipTournamentId => {
          return tournaments.every(tournament => tournament.id !== championshipTournamentId);
        }) && tournaments.every(tournament => championship.sportId === tournament.sportId)
      );
    });

    return (
      <SimpleModal isOpen={isOpen} title={''}>
        <TournamentAddToChampionshipModal
          user={user}
          onSubmitChampionshipClick={this.onSubmitChampionshipClick}
          onCancelClick={this.onCloseAddTournamentToChampionshipModalClick}
          championships={onlyUnusedChampionships}
          tournaments={tournaments}
          isOpen={true}
        />
      </SimpleModal>
    );
  }

  renderTournamentRemoveToChampionshipModal(): React.ReactNode {
    const { user } = this.props;
    const { selectedItems, isRemoveTournamentToChampionshipModalOpen, championships } = this.state;
    const tournaments = selectedItems;

    return (
      <SimpleModal isOpen={isRemoveTournamentToChampionshipModalOpen} title={''}>
        <TournamentRemoveToChampionshipModal
          user={user}
          onSubmitChampionshipClick={this.onSubmitChampionshipClick}
          onCancelClick={this.onCloseRemoveTournamentToChampionshipModalClick}
          championships={championships}
          tournaments={tournaments}
          isOpen={true}
        />
      </SimpleModal>
    );
  }

  onAddEventFormCancel = (): void => {
    if (this.state.isAddEventDirty) {
      this.setState({ isDiscardAddEventOpen: true });
      return;
    }
    this.setState({
      isAddEventModalOpen: false
    });
  };

  onAddEventDirtyChange = (isAddEventDirty: boolean): void => {
    if (this.state.isAddEventDirty !== isAddEventDirty) this.setState({ isAddEventDirty });
  };

  discardAddEventChanges = (): void => {
    this.setState({ isAddEventModalOpen: false, isAddEventDirty: false, isDiscardAddEventOpen: false });
  };

  onAddEventFormSubmit = (data: any): void => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { selectedItems } = this.state;
    const tournament = selectedItems[0];
    const { id } = tournament;

    const { gender, ages, sportId, start, end, groupId, venue, teams, participants, shortDescription, pitchId } = data;
    const agesNumber = ages.map(age => Number(age));

    //Important! Modify seconds and milliseconds in start time for navigation
    const now = new Date();
    const nowS = now.getSeconds();
    const nowMs = now.getMilliseconds();
    start.setSeconds(nowS, nowMs);

    const body = {
      gender: gender,
      eventType: 'EXTERNAL_SCHOOLS',
      ages: agesNumber,
      sportId: sportId,
      startTime: start.toISOString(),
      endTime: end.toISOString(),
      inviterSchoolId: activeSchoolId,
      tournamentId: id,
      tournamentGroupId: groupId,
      shortDescription: shortDescription || '',
      venue: {
        venueType: venue.venueType,
        point: venue.venueType === EVENT_VENUE.TBD ? DEFAULT_POINT : venue.point
      }
    };

    if (isTeamTournament(tournament) || isMiniTeamTournament(tournament)) {
      const teamsUniq = Lazy(teams)
        .map(team => team.schoolId)
        .uniq()
        .toArray();

      propz.set(body, ['invitedSchoolIds'], teamsUniq);
    }

    if (isIndividualTournament(tournament)) {
      const schoolIds = Lazy(participants)
        .map(participant => participant.schoolId)
        .uniq()
        .toArray();

      propz.set(body, ['invitedSchoolIds'], schoolIds);
    }

    const postcodeId = propz.get(data, ['venue', 'postcodeData', 'id']);
    const placeId = propz.get(data, ['venue', 'postcodeData', 'placeId']);

    if (typeof postcodeId !== 'undefined') {
      propz.set(body, ['venue', 'postcodeId'], postcodeId);
      if (typeof placeId !== 'undefined') {
        propz.set(body, ['venue', 'placeId'], placeId);
      }
    }

    this.setState({
      isLoading: true
    });

    let createdEventId: string | undefined;
    let isEventActivated = false;
    createEvent(user, body)
      .then(async event => {
        createdEventId = event.id;
        if (pitchId) await assignPitchByTournamentIdAndEventId(user, { pitchId }, id, event.id);
        if (!isIndividualTournament(tournament)) {
          await Promise.all(
            data.teams.map(team => {
              const teamToPost = {
                ...team,
                cloneOf: team.id,
                teamType: TEAM_TYPE.CLONE,
                players: isMiniTeamTournament(tournament) ? [] : team.players
              };
              return addTeam(user, id, event.id, teamToPost);
            })
          );
        }
        await activateEvent(user, event.id);
        isEventActivated = true;
      })
      .then(teams => {
        return getAllTournamentEvents(user, id);
      })
      .then(events => {
        this.setState({
          isAddEventModalOpen: false,
          isAddEventDirty: false,
          isLoading: false,
          tournamentEvents: events
        });
      })
      .catch(async error => {
        if (createdEventId && !isEventActivated) {
          await deleteEvent(user, createdEventId).catch(cleanupError => {
            console.error('[TournamentsUpcoming] failed to remove incomplete draft event', cleanupError);
          });
        }
        this.setState({
          isLoading: false,
          isAddEventDirty: true
        });
        console.error('[TournamentsUpcoming] event creation failed', error);
      });
  };

  renderAddEventModal(): React.ReactNode {
    const { isAddEventModalOpen, selectedItems, participants } = this.state;
    const { user } = this.props;
    const tournament = selectedItems[0];

    return (
      <>
        <SimpleModal
          isOpen={isAddEventModalOpen}
          title="Add tournament event"
          customClass="utmFixtureModal"
          dialogStyle={{ maxWidth: 760 }}
          showFooter={false}
          isBodyBold={false}
          onCloseClick={this.onAddEventFormCancel}
          onBackdropClick={this.onAddEventFormCancel}
        >
          <TournamentAddEventForm
            tournament={tournament}
            onSubmit={this.onAddEventFormSubmit}
            onCancel={this.onAddEventFormCancel}
            user={user}
            participants={participants}
            onDirtyChange={this.onAddEventDirtyChange}
          />
        </SimpleModal>
        <UnsavedChangesModal
          isOpen={this.state.isDiscardAddEventOpen}
          message="You have unsaved tournament event details. If you close now, those changes will be lost."
          onKeepEditing={() => this.setState({ isDiscardAddEventOpen: false })}
          onDiscard={this.discardAddEventChanges}
        />
      </>
    );
  }

  createGroupEvents() {
    const { eventsForGroupFormSubmitData, selectedItems } = this.state;
    const { user } = this.props;
    const tournamentId = selectedItems[0].id;

    this.setState({
      isInformationModalShow: false,
      isLoading: true
    });

    addGroupEvents(user, tournamentId, eventsForGroupFormSubmitData)
      .then(
        () => {
          getAllTournamentEvents(user, tournamentId).then(events => {
            this.setState({
              tournamentEvents: events,
              isLoading: false,
              isInformationModalShow: true,
              modalText: 'Events have been added successfully',
              modalTitle: ''
            });
          });
        },
        err => {
          this.setState({
            isLoading: false,
            isInformationModalShow: true,
            modalText: `Error: ${err.response.data.details.text}`,
            modalTitle: 'Error'
          });
        }
      )
      .catch(err => {
        this.setState({
          isLoading: false,
          isInformationModalShow: true,
          modalText: `Error: ${err.response.data.details.text}`,
          modalTitle: 'Error'
        });
      });
  }

  onDefaultGroupsFormCancel = () => {
    this.setState({
      isDefaultGroupsModalOpen: false
    });
  };

  onCreateEventsForGroupFormCancel = () => {
    this.setState({
      isCreateEventsForGroupModalOpen: false
    });
  };

  onCreateEventsForGroupFormSubmit = data => {
    const { selectedItems, tournamentEvents } = this.state;
    const tournament = selectedItems[0];

    this.setState({
      eventsForGroupFormSubmitData: data,
      isCreateEventsForGroupModalOpen: false
    });

    const events = tournamentEvents || [];

    const eventIds = events
      .filter(
        event =>
          event.tournamentGroupId === data.tournamentGroupId &&
          event.ages.some(eventAge => eventAge === data.age) &&
          event.gender === data.gender
      )
      .map(event => event.id);

    this.onCreateEventsForGroupFormCancel();

    if (eventIds.length > 0) {
      const group = tournament.customGroups.find(customGroup => customGroup.id === data.tournamentGroupId);
      const groupName = group ? group.name : 'group';

      const bodyText = `There are ${eventIds.length} events in ${
        AGE_GROUPS['U5-U18'][data.age]
      } ${groupName}. Creating new events will remove the existing ones. Are you sure?`;

      this.setState({
        isRemoveExistingEventsModalShow: true,
        modalText: bodyText,
        modalTitle: 'Remove the existing events'
      });
    } else {
      this.createGroupEvents();
    }
  };

  onDefaultGroupsFormSubmit = (data): void => {
    const { selectedItems } = this.state;
    const { user } = this.props;
    const tournament = selectedItems[0];
    const { customGroups: tournamentCustomGroups, tournamentLayout, id } = tournament;

    let groupNames: { name: string }[] = [];
    let promises: Promise<any>[] = [];

    for (const key in data) {
      const isTrue = data[key] === true;
      const isFalse = data[key] === false;

      const mappedGroupName = TOURNAMENT_GROUP_TAG_MAPPING[key];
      const isCustomGroupExist = tournamentCustomGroups.some(customGroup => customGroup.name === mappedGroupName);

      if (isTrue && !isCustomGroupExist) {
        groupNames.push({
          name: mappedGroupName
        });
      }

      if (isFalse && isCustomGroupExist) {
        const customGroup = tournamentCustomGroups.find(customGroup => customGroup.name === mappedGroupName);

        if (customGroup) {
          promises.push(deleteTournamentGroup(user, id, customGroup.id));
        }
      }
    }

    const groupsWithStage = groupNames
      .map(groupName => {
        const isGroupStage = TOURNAMENT_GROUP_STAGE.some(group => group === groupName.name);
        const isQualifierStage = TOURNAMENT_QUALIFIER_STAGE.some(group => group === groupName.name);
        const isPlayoffStage = TOURNAMENT_PLAYOFF_STAGE.some(group => group === groupName.name);
        const isFinalStage = TOURNAMENT_FINAL_STAGE.some(group => group === groupName.name);

        switch (true) {
          case isGroupStage:
            return {
              name: groupName.name,
              stage: TOURNAMENT_LAYOUT_TYPE.GROUP
            };

          case isQualifierStage:
            return {
              name: groupName.name,
              stage: TOURNAMENT_LAYOUT_TYPE.QUALIFIER
            };

          case isPlayoffStage:
            return {
              name: groupName.name,
              stage: TOURNAMENT_LAYOUT_TYPE.PLAYOFF
            };

          case isFinalStage:
            return {
              name: groupName.name,
              stage: TOURNAMENT_LAYOUT_TYPE.FINAL
            };

          default:
            return undefined;
        }
      })
      .filter(
        (groupWithStage): groupWithStage is { name: string; stage: string } => typeof groupWithStage !== 'undefined'
      );

    const stagesNoCreated = groupsWithStage
      .map(groupWithStage => {
        return tournamentLayout.find(stage => stage.type === groupWithStage.stage);
      })
      .filter(stage => typeof stage === 'undefined');

    if (stagesNoCreated.length === 0) {
      const groupsWithStageId = groupsWithStage
        .map(groupWithStage => {
          const stage = tournamentLayout.find(stage => stage.type === groupWithStage.stage);

          if (!stage) {
            return undefined;
          }

          return {
            name: groupWithStage.name,
            stageId: stage.id
          };
        })
        .filter(
          (groupWithStageId): groupWithStageId is { name: string; stageId: string } =>
            typeof groupWithStageId !== 'undefined'
        );

      promises = groupsWithStageId.map(groupWithStageId => {
        return createTournamentGroup(user, id, groupWithStageId);
      });

      this.setState({
        isLoading: true
      });

      Promise.all(promises).then(() => {
        getTournament(user, id).then(nextTournament => {
          this.setState({
            isLoading: false,
            isDefaultGroupsModalOpen: false,
            selectedItems: [nextTournament]
          });
        });
      });
    }
  };

  renderDefaultGroupsModal(): React.ReactNode {
    const { isDefaultGroupsModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];

    return (
      <SimpleModal isOpen={isDefaultGroupsModalOpen} title={'Default groups'}>
        <TournamentDefaultGroupsForm
          tournament={tournament}
          onSubmit={this.onDefaultGroupsFormSubmit}
          onCancel={this.onDefaultGroupsFormCancel}
        />
      </SimpleModal>
    );
  }

  renderCreateEventsForGroupModal(): React.ReactNode {
    const { isCreateEventsForGroupModalOpen, selectedItems } = this.state;
    const { user } = this.props;
    const tournament = selectedItems[0];

    return (
      <SimpleModal
        isOpen={isCreateEventsForGroupModalOpen}
        title="Create events for a group"
        customClass="utmFixtureModal"
        dialogStyle={{ maxWidth: 620 }}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.onCreateEventsForGroupFormCancel}
        onBackdropClick={this.onCreateEventsForGroupFormCancel}
      >
        <TournamentEventsGroupForm
          user={user}
          tournament={tournament}
          onSubmit={this.onCreateEventsForGroupFormSubmit}
          onCancel={this.onCreateEventsForGroupFormCancel}
        />
      </SimpleModal>
    );
  }

  onConfirmationRequestsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const tournament = selectedItems[0];
    const tournamentId = tournament.id;

    const { history, location } = this.props;
    const { search } = location;
    const { basePath } = this.state;

    history.push({
      pathname: `/tournaments/confirmationRequests/send`,
      search: `tournament=${tournamentId}`,
      state: {
        search,
        prevPath: basePath,
        inviteKind: INVITE_KIND.TOURNAMENT_SCHOOL_INVITE as INVITE_KIND_TYPE
      }
    });
  };

  renderSummary(): React.ReactNode {
    const { currentTabIndex, selectedItems, tournamentEvents } = this.state;
    const isOneItemSelected = this.isOneItemSelected();

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a tournament above</div>;
    }

    const tournament = selectedItems[0];
    const customGroups = tournament.customGroups || [];
    const isCustomGroupExist = customGroups.length > 0;
    const summaryTabs = this.getSummaryTabs();
    const tabs = isTeamTournament(tournament) || isMiniTeamTournament(tournament)
      ? TEAM_TOURNAMENT_TABS
      : isIndividualTournament(tournament) ? INDIVIDUAL_TOURNAMENT_TABS : TOURNAMENT_TABS;
    const currentTab = tabs[currentTabIndex];

    const isShowNotificationsButtons = currentTab === TABS.SUMMARY;
    const isEditParticipantsButton = currentTab === TABS.PARTICIPANTS;
    const isEditEligibleSchoolsButton = currentTab === TABS.ELIGIBLE_SCHOOLS;
    const isShowWaitingListButton = currentTab === TABS.WAITING_LIST;
    const isShowConfirmationRequestsButtons = currentTab === TABS.CONFIRMATION_REQUESTS;
    const isShowEditEventsButton = currentTab === TABS.TOURNAMENT_EVENTS && tournamentEvents.length > 0;
    const isShowAddEventButton = currentTab === TABS.TOURNAMENT_EVENTS;
    const isShowCreateEventsGroupButton =
      currentTab === TABS.TOURNAMENT_EVENTS && (isTeamTournament(tournament) || isMiniTeamTournament(tournament));
    const isShowAutoEnrollmentButton = currentTab === TABS.AUTO_ENROLLMENT;
    const isShowPublicSiteSettingsButton = currentTab === TABS.PUBLIC_SITE_SETTINGS;
    const isShowTournamentTVButton =
      currentTab === TABS.TOURNAMENT_TV && (isTeamTournament(tournament) || isMiniTeamTournament(tournament));
    const isShowEnrollmentLogsButton = currentTab === TABS.ENROLLMENT_LOG;
    const isShowAdminsButton = currentTab === TABS.ADMINS;
    const isShowEditPitchesButton = currentTab === TABS.PITCHES;
    const isShowGroupsButtons = currentTab === TABS.GROUPS;
    const isShowEditTeamsButton = currentTab === TABS.TEAMS;

    return (
      <div className="tournamentSummaryCard">
        <GenericSummary
          onTabClick={this.onTabClick}
          tabs={tabs}
          currentTabIndex={currentTabIndex}
          customClass="tournamentSummaryTabs"
        >
          <div className="tournamentSummaryActions">
            {isShowNotificationsButtons && (
              <>
                <Button
                  onClick={this.onShowNotificationsButtonClick}
                  text={'Show notifications'}
                  customClass={'mt-3 mr-3 mb-3'}
                />
              </>
            )}

            {isEditParticipantsButton && (
              <Button
                onClick={this.onEditParticipantsButtonClick}
                text={'Edit participants'}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isEditEligibleSchoolsButton && (
              <>
                <Button
                  onClick={this.onEditEligibleSchoolsButtonClick}
                  text={'Edit eligible schools'}
                  customClass={'mt-3 mr-3 mb-3'}
                />
                {this.hasSchoolUnionParticipant() && (
                  <Button
                    onClick={this.onManageAthleteSchoolsButtonClick}
                    text={'Manage athlete schools'}
                    customClass={'mt-3 mb-3'}
                  />
                )}
              </>
            )}

            {isShowWaitingListButton && (
              <Button
                onClick={this.onShowWaitingListButtonClick}
                text={'Show waiting list'}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isShowConfirmationRequestsButtons && (
              <>
                <Button
                  onClick={this.onConfirmationRequestsButtonClick}
                  text={'Send confirmation requests'}
                  customClass={'mt-3 mr-3 mb-3'}
                />
                <Button
                  onClick={this.onShowConfirmationRequestsButtonClick}
                  text={'Show confirmation requests'}
                  customClass={'mt-3 mr-3 mb-3'}
                />
              </>
            )}

            {isShowAutoEnrollmentButton && (
              <Button
                onClick={this.onEditAutoEnrollmentButtonClick}
                text={'Autoenrollment settings '}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isShowPublicSiteSettingsButton && (
              <Button
                onClick={this.onEditPublicSiteSettingsButtonClick}
                text={'Edit tournament website settings'}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isShowTournamentTVButton && (
              <Button
                onClick={this.onEditTournamentTVButtonClick}
                text={'Manage Tournament TV'}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isShowAddEventButton && (
              <Button onClick={this.onAddEventButtonClick} text={'Add events'} customClass={'mt-3 mb-3 mr-3'} />
            )}

            {isShowEditEventsButton && (
              <Button onClick={this.onEditEventsButtonClick} text={'Edit events'} customClass={'mt-3 mb-3 mr-3'} />
            )}

            {currentTab === TABS.TOURNAMENT_EVENTS && (
              <Button
                onClick={this.openAssignEventNumbersModal}
                text={'Assign event numbers'}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isShowCreateEventsGroupButton && (
              <Button
                onClick={this.onCreateEventsForGroupButtonClick}
                text={'Create events for a group'}
                customClass={'mt-3 mb-3'}
              />
            )}

            {isShowEnrollmentLogsButton && (
              <Button onClick={this.onShowEnrollmentLogsButtonClick} text={'View log'} customClass={'mt-3 mb-3'} />
            )}

            {isShowAdminsButton && (
              <Button onClick={this.onShowAdminsButtonClick} text={'Show admins'} customClass={'mt-3 mb-3'} />
            )}

            {isShowEditPitchesButton && (
              <Button onClick={this.onShowPitchesButtonClick} text={'Edit pitches'} customClass={'mt-3 mb-3'} />
            )}

            {isShowGroupsButtons && (
              <>
                <Button
                  onClick={this.onAddDefaultGroupsButtonClick}
                  text={'Add default groups'}
                  customClass={'mt-3 mb-3 mr-3'}
                />
                <Button
                  onClick={this.onEditCustomGroupsButtonClick}
                  text={'Edit custom groups'}
                  customClass={'mt-3 mb-3 mr-3'}
                />
                <Button
                  onClick={this.onGridButtonClick}
                  text={'Grid'}
                  customClass={'mt-3 mb-3'}
                  disabled={!isCustomGroupExist}
                />
              </>
            )}

            {isShowEditTeamsButton && (
              <Button onClick={this.onEditTeamsButtonClick} text={'Edit teams'} customClass={'mt-3 mb-3'} />
            )}
          </div>

          {summaryTabs}
        </GenericSummary>
      </div>
    );
  }

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId, activeSchool } = user;
    const { selectedItems } = this.state;
    const tournament = selectedItems[0];
    const tournamentId = propz.get(tournament, ['id'], '');

    const {
      dateTo,
      dateFrom,
      isShowAccepted,
      isShowRejected,
      isShowUnresponded,
      isShowNotSent,
      isShowZero,
      isShowNonZero,
      isShowBlank,
      isHighlightNoAge,
      isShowSchedule,
      isPrintFullNames,
      isShowAllAdmins,
      isPrintScoreCards
    } = data;

    let modData;
    let formsUniq;

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EXTENDED_TOURNAMENT_SCHEDULE:
        this.setState({
          isExtendedTournamentScheduleReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            unionId: activeSchoolId
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_SCHOOLS:
        this.setState({
          isTournamentSchoolsReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showAllAdmins: isShowAllAdmins
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_TEAM_MEMBERS:
        this.setState({
          isTournamentTeamMembersReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showBlank: isShowBlank,
            highlightNoAge: isHighlightNoAge
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_PARTICIPATION_CONFIRMATIONS:
        this.setState({
          isTournamentParticipationConfirmationsReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showAccepted: isShowAccepted,
            showRejected: isShowRejected,
            showUnresponded: isShowUnresponded,
            showNotSent: isShowNotSent,
            printResponseMetadata: true
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_START_LIST:
        this.setState({
          isTournamentStartListReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showBlank: isShowBlank,
            highlightNoAge: isHighlightNoAge,
            printScoreCards: isPrintScoreCards
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_MEMBER_SCHOOLS_STATISTICS:
        this.setState({
          isUnionMemberSchoolsStatisticsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            unionId: activeSchoolId,
            showZero: isShowZero,
            showNonZero: isShowNonZero
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_MEMBER_SCHOOLS_TOURNAMENTS:
        this.setState({
          isUnionMemberSchoolsTournamentsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            unionId: activeSchoolId
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_MEMBER_SCHOOLS_TOURNAMENTS_AS_PART_OF_UNION:
        this.setState({
          isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: Moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: Moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            unionId: activeSchoolId
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_PLAYERS:
        this.setState({
          isTournamentPlayersReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showBlank: isShowBlank
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.HIGH_LEVEL_TOURNAMENT_SCHOOL_ADMINS:
        this.setState({
          isHighLevelTournamentSchoolAdminsReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showAllAdmins: isShowAllAdmins
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_SCORE_CARDS:
        this.setState({
          isTournamentScoreCardsReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showSchedule: isShowSchedule
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_RESULTS_INDIVIDUAL:
        this.setState({
          isTournamentResultsIndividualReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            unionId: activeSchoolId,
            tournamentId,
            showBlank: isShowBlank,
            printFullNames: isPrintFullNames
          }
        };
        break;
    }

    uploadReport(user, reportType, modData)
      .then(data => {
        if (typeof data.reportId !== 'undefined') {
          const reportType = data.reportType;

          this.setState({
            isLoading: false
          });

          const url = `${window.apiBase}/public/report/${data.reportId}/reportType/${reportType}`;
          window.open(url);
        } else {
          this.setState({
            isLoading: false,
            errorMessage: 'No read report',
            isErrorModalOpen: true
          });
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  openExtendedTournamentScheduleReportForm = () => {
    this.setState({
      isExtendedTournamentScheduleReportModalOpen: true
    });
  };

  openReportsSelectionModal = (): void => {
    this.setState({ isReportsSelectionModalOpen: true });
  };

  closeReportsSelectionModal = (): void => {
    this.setState({ isReportsSelectionModalOpen: false });
  };

  selectReport = (action: () => void): void => {
    this.setState({ isReportsSelectionModalOpen: false }, action);
  };

  getAvailableReports = () => {
    const { selectedItems } = this.state;
    const selectedTournament = selectedItems[0];

    if (selectedItems.length === 0) {
      return [
        {
          name: 'Extended tournament schedule',
          description: 'A complete schedule across the union tournaments.',
          action: this.openExtendedTournamentScheduleReportForm
        },
        {
          name: 'Member schools statistics',
          description: 'Tournament statistics for union member schools.',
          action: this.openUnionMemberSchoolsStatisticsReportForm
        },
        {
          name: 'Member schools tournament participation',
          description: 'Participation by member schools across tournaments.',
          action: this.openUnionMemberSchoolsTournamentsReportForm
        },
        {
          name: 'Member schools tournament participation (as part of area team)',
          description: 'Participation by schools represented through area teams.',
          action: this.openUnionMemberSchoolsTournamentsAsPartOfUnionReportForm
        }
      ];
    }

    if (selectedItems.length > 1) {
      return [
        {
          name: 'Extended tournament schedule',
          description: `Schedule report available while ${selectedItems.length} tournaments are selected.`,
          action: this.openExtendedTournamentScheduleReportForm
        }
      ];
    }

    const reports = [
      {
        name: 'Tournament schools',
        description: 'Schools taking part in the selected tournament.',
        action: this.openTournamentSchoolsReportForm
      },
      {
        name: 'Tournament team members',
        description: 'Team members entered in the selected tournament.',
        action: this.openTournamentTeamMembersReportForm
      },
      {
        name: 'Tournament participation confirmations',
        description: 'Participation confirmation status for the selected tournament.',
        action: this.openTournamentParticipationConfirmationsReportForm
      },
      {
        name: 'Tournament players',
        description: 'Player list for the selected tournament.',
        action: this.openTournamentPlayersReportForm
      },
      {
        name: 'Tournament schools contact details',
        description: 'Contact details for participating schools.',
        action: this.openHighLevelTournamentSchoolAdminsReportForm
      }
    ];

    if (selectedTournament && isIndividualTournament(selectedTournament)) {
      reports.push(
        {
          name: 'Tournament start list',
          description: 'Start list for the selected individual tournament.',
          action: this.openTournamentStartListReportForm
        },
        {
          name: 'Tournament results',
          description: 'Results for the selected individual tournament.',
          action: this.openTournamentResultsIndividualReportForm
        }
      );
    }

    if (selectedTournament && isTeamTournament(selectedTournament)) {
      reports.push({
        name: 'Tournament score cards',
        description: 'Printable score cards for the selected team tournament.',
        action: this.openTournamentScoreCardsReportForm
      });
    }

    if (selectedTournament && isIndividualTournament(selectedTournament)) {
      reports.push({
        name: 'Meet pack (ZIP)',
        description: 'Download the meet pack for the selected individual tournament.',
        action: this.onDownloadMeetPackClick
      });
    }

    return reports;
  };

  renderReportsSelectionModal(): React.ReactNode {
    const { isReportsSelectionModalOpen, selectedItems } = this.state;
    const reports = this.getAvailableReports();
    const scope =
      selectedItems.length === 0
        ? 'Union reports'
        : selectedItems.length === 1
        ? 'Selected tournament reports'
        : 'Multiple tournament reports';

    return (
      <SimpleModal
        customClass="eEventPrintModal unionTournamentReportsModal"
        isOpen={isReportsSelectionModalOpen}
        title="Printed forms & reports"
        onCloseClick={this.closeReportsSelectionModal}
        showFooter={false}
        isBodyBold={false}
      >
        <div className="eEventPrintModal__intro">
          Choose a report. You can configure its contents and format on the next step.
        </div>
        <section className="eEventPrintModal__group">
          <h3 className="eEventPrintModal__groupTitle">{scope}</h3>
          <div className="eEventPrintModal__list">
            {reports.map(report => (
              <button
                type="button"
                className="eEventPrintModal__item"
                key={report.name}
                onClick={() => this.selectReport(report.action)}
              >
                <span className="eEventPrintModal__itemIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
                  </svg>
                </span>
                <span className="eEventPrintModal__itemCopy">
                  <span className="eEventPrintModal__itemHeading">
                    <span>{report.name}</span>
                    <span className="eEventPrintModal__format">
                      {report.name === 'Meet pack (ZIP)' ? 'ZIP' : 'Excel'}
                    </span>
                  </span>
                  <span className="eEventPrintModal__itemDescription">{report.description}</span>
                </span>
                <span className="eEventPrintModal__arrow" aria-hidden="true">
                  ›
                </span>
              </button>
            ))}
          </div>
        </section>
      </SimpleModal>
    );
  }

  closeExtendedTournamentScheduleReportForm = () => {
    this.setState({
      isExtendedTournamentScheduleReportModalOpen: false
    });
  };

  openTournamentSchoolsReportForm = () => {
    this.setState({
      isTournamentSchoolsReportModalOpen: true
    });
  };

  closeTournamentSchoolsReportForm = () => {
    this.setState({
      isTournamentSchoolsReportModalOpen: false
    });
  };

  openTournamentTeamMembersReportForm = () => {
    this.setState({
      isTournamentTeamMembersReportModalOpen: true
    });
  };

  closeTournamentTeamMembersReportForm = () => {
    this.setState({
      isTournamentTeamMembersReportModalOpen: false
    });
  };

  openTournamentParticipationConfirmationsReportForm = () => {
    this.setState({
      isTournamentParticipationConfirmationsReportModalOpen: true
    });
  };

  closeTournamentParticipationConfirmationsReportForm = () => {
    this.setState({
      isTournamentParticipationConfirmationsReportModalOpen: false
    });
  };

  openTournamentStartListReportForm = () => {
    this.setState({
      isTournamentStartListReportModalOpen: true
    });
  };

  closeTournamentStartListReportForm = () => {
    this.setState({
      isTournamentStartListReportModalOpen: false
    });
  };

  openUnionMemberSchoolsStatisticsReportForm = () => {
    this.setState({
      isUnionMemberSchoolsStatisticsReportModalOpen: true
    });
  };

  closeUnionMemberSchoolsStatisticsReportForm = () => {
    this.setState({
      isUnionMemberSchoolsStatisticsReportModalOpen: false
    });
  };

  openUnionMemberSchoolsTournamentsReportForm = () => {
    this.setState({
      isUnionMemberSchoolsTournamentsReportModalOpen: true
    });
  };

  closeUnionMemberSchoolsTournamentsReportForm = () => {
    this.setState({
      isUnionMemberSchoolsTournamentsReportModalOpen: false
    });
  };

  openUnionMemberSchoolsTournamentsAsPartOfUnionReportForm = () => {
    this.setState({
      isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen: true
    });
  };

  closeUnionMemberSchoolsTournamentsAsPartOfUnionReportForm = () => {
    this.setState({
      isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen: false
    });
  };

  openTournamentPlayersReportForm = () => {
    this.setState({
      isTournamentPlayersReportModalOpen: true
    });
  };

  closeTournamentPlayersReportForm = () => {
    this.setState({
      isTournamentPlayersReportModalOpen: false
    });
  };

  openHighLevelTournamentSchoolAdminsReportForm = () => {
    this.setState({
      isHighLevelTournamentSchoolAdminsReportModalOpen: true
    });
  };

  closeHighLevelTournamentSchoolAdminsReportForm = () => {
    this.setState({
      isHighLevelTournamentSchoolAdminsReportModalOpen: false
    });
  };

  openTournamentScoreCardsReportForm = () => {
    this.setState({
      isTournamentScoreCardsReportModalOpen: true
    });
  };

  closeTournamentScoreCardsReportForm = () => {
    this.setState({
      isTournamentScoreCardsReportModalOpen: false
    });
  };

  openTournamentResultsIndividualReportForm = () => {
    this.setState({
      isTournamentResultsIndividualReportModalOpen: true
    });
  };

  closeTournamentResultsIndividualReportForm = () => {
    this.setState({
      isTournamentResultsIndividualReportModalOpen: false
    });
  };

  renderReportParametersTitle = (title: string): React.ReactNode => (
    <div className="unionTournamentReportTitle">
      <span className="unionTournamentReportTitle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
        </svg>
      </span>
      <span>
        <strong>{title}</strong>
        <small>Tournament report</small>
      </span>
    </div>
  );

  renderReportParametersModal = (
    isOpen: boolean,
    title: string,
    onCloseClick: () => void,
    content: React.ReactNode
  ): React.ReactNode => (
    <SimpleModal
      isOpen={isOpen}
      title={this.renderReportParametersTitle(title)}
      customClass="unionTournamentReportParametersModal"
      bodyClassName="unionTournamentReportParametersModal__body"
      dialogStyle={{ maxWidth: 480 }}
      showFooter={false}
      isBodyBold={false}
      onCloseClick={onCloseClick}
    >
      {content}
    </SimpleModal>
  );

  renderExtendedTournamentScheduleReportFormModal() {
    const { isExtendedTournamentScheduleReportModalOpen } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return this.renderReportParametersModal(
      isExtendedTournamentScheduleReportModalOpen,
      'Extended tournament schedule',
      this.closeExtendedTournamentScheduleReportForm,
      <ExtendedTournamentScheduleReportForm
        onCloseClick={this.closeExtendedTournamentScheduleReportForm}
        onSubmit={this.onSubmitReportForm}
      />
    );
  }

  renderTournamentSchoolsReportFormModal() {
    const { isTournamentSchoolsReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentSchoolsReportModalOpen,
      'Tournament schools',
      this.closeTournamentSchoolsReportForm,
      <TournamentSchoolsReportForm
        onCloseClick={this.closeTournamentSchoolsReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderTournamentTeamMembersReportFormModal() {
    const { isTournamentTeamMembersReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentTeamMembersReportModalOpen,
      'Tournament team members',
      this.closeTournamentTeamMembersReportForm,
      <TournamentTeamMembersReportForm
        onCloseClick={this.closeTournamentTeamMembersReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderTournamentParticipationConfirmationsReportFormModal() {
    const { isTournamentParticipationConfirmationsReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentParticipationConfirmationsReportModalOpen,
      'Tournament participation confirmations',
      this.closeTournamentParticipationConfirmationsReportForm,
      <TournamentParticipationConfirmationsReportForm
        onCloseClick={this.closeTournamentParticipationConfirmationsReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderTournamentStartListReportFormModal() {
    const { isTournamentStartListReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentStartListReportModalOpen,
      'Tournament start list',
      this.closeTournamentStartListReportForm,
      <TournamentStartListReportForm
        onCloseClick={this.closeTournamentStartListReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderUnionMemberSchoolsStatisticsReportFormModal() {
    const { isUnionMemberSchoolsStatisticsReportModalOpen } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return this.renderReportParametersModal(
      isUnionMemberSchoolsStatisticsReportModalOpen,
      'Member schools statistics',
      this.closeUnionMemberSchoolsStatisticsReportForm,
      <UnionMemberSchoolsStatisticsReportForm
        onCloseClick={this.closeUnionMemberSchoolsStatisticsReportForm}
        onSubmit={this.onSubmitReportForm}
      />
    );
  }

  renderUnionMemberSchoolsTournamentsReportFormModal() {
    const { isUnionMemberSchoolsTournamentsReportModalOpen } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return this.renderReportParametersModal(
      isUnionMemberSchoolsTournamentsReportModalOpen,
      'Member schools participation in tournaments',
      this.closeUnionMemberSchoolsTournamentsReportForm,
      <UnionMemberSchoolsTournamentsReportForm
        onCloseClick={this.closeUnionMemberSchoolsTournamentsReportForm}
        onSubmit={this.onSubmitReportForm}
      />
    );
  }

  renderUnionMemberSchoolsTournamentsAsPartOfUnionReportFormModal() {
    const { isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return this.renderReportParametersModal(
      isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen,
      'Member schools participation as part of area team',
      this.closeUnionMemberSchoolsTournamentsAsPartOfUnionReportForm,
      <UnionMemberSchoolsTournamentsAsPartOfUnionReportForm
        onCloseClick={this.closeUnionMemberSchoolsTournamentsAsPartOfUnionReportForm}
        onSubmit={this.onSubmitReportForm}
      />
    );
  }

  renderTournamentPlayersReportFormModal() {
    const { isTournamentPlayersReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentPlayersReportModalOpen,
      'Tournament players',
      this.closeTournamentPlayersReportForm,
      <TournamentPlayersReportForm
        onCloseClick={this.closeTournamentPlayersReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderHighLevelTournamentSchoolAdminsReportFormModal() {
    const { isHighLevelTournamentSchoolAdminsReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isHighLevelTournamentSchoolAdminsReportModalOpen,
      'Participating schools and contact details',
      this.closeHighLevelTournamentSchoolAdminsReportForm,
      <HighLevelTournamentSchoolAdminsReportForm
        onCloseClick={this.closeHighLevelTournamentSchoolAdminsReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderTournamentScoreCardsReportFormModal() {
    const { isTournamentScoreCardsReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentScoreCardsReportModalOpen,
      'Tournament score cards',
      this.closeTournamentScoreCardsReportForm,
      <TournamentScoreCardsReportForm
        onCloseClick={this.closeTournamentScoreCardsReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  renderTournamentResultsIndividualReportFormModal() {
    const { isTournamentResultsIndividualReportModalOpen, selectedItems } = this.state;
    const tournament = selectedItems[0];
    return this.renderReportParametersModal(
      isTournamentResultsIndividualReportModalOpen,
      'Tournament results',
      this.closeTournamentResultsIndividualReportForm,
      <TournamentResultsIndividualReportForm
        onCloseClick={this.closeTournamentResultsIndividualReportForm}
        onSubmit={this.onSubmitReportForm}
        tournament={tournament}
      />
    );
  }

  render() {
    const {
      isLoading,
      tournamentTags,
      isEditableAutoEnrollment,
      isEditablePublicSiteSettings,
      isInformationModalShow,
      isRemoveExistingEventsModalShow,
      isAddTournamentToChampionshipModalOpen,
      isRemoveTournamentToChampionshipModalOpen,
      isAddEventModalOpen,
      isDefaultGroupsModalOpen,
      isEditableTournamentTVSettings,
      isTournamentTagModalOpen,
      isExtendedTournamentScheduleReportModalOpen,
      isTournamentParticipationConfirmationsReportModalOpen,
      isTournamentStartListReportModalOpen,
      isUnionMemberSchoolsStatisticsReportModalOpen,
      isUnionMemberSchoolsTournamentsReportModalOpen,
      isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen,
      isTournamentPlayersReportModalOpen,
      isHighLevelTournamentSchoolAdminsReportModalOpen,
      isTournamentScoreCardsReportModalOpen,
      isTournamentResultsIndividualReportModalOpen,
      isReportsSelectionModalOpen
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isEditableAutoEnrollment ||
      isEditablePublicSiteSettings ||
      isInformationModalShow ||
      isAddTournamentToChampionshipModalOpen ||
      isRemoveTournamentToChampionshipModalOpen ||
      isAddEventModalOpen ||
      isDefaultGroupsModalOpen ||
      isRemoveExistingEventsModalShow ||
      isEditableTournamentTVSettings ||
      isTournamentTagModalOpen ||
      isExtendedTournamentScheduleReportModalOpen ||
      isTournamentParticipationConfirmationsReportModalOpen ||
      isTournamentStartListReportModalOpen ||
      isUnionMemberSchoolsStatisticsReportModalOpen ||
      isUnionMemberSchoolsTournamentsReportModalOpen ||
      isUnionMemberSchoolsTournamentsAsPartOfUnionReportModalOpen ||
      isTournamentPlayersReportModalOpen ||
      isHighLevelTournamentSchoolAdminsReportModalOpen ||
      isTournamentScoreCardsReportModalOpen ||
      isTournamentResultsIndividualReportModalOpen ||
      isReportsSelectionModalOpen
        ? 'unionTournamentsPage modal-open'
        : 'unionTournamentsPage';

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderTournamentTVModal()}
        {this.renderRemoveExistingEventsModalShowModal()}
        {this.renderAutoEnrollmentModal()}
        {this.renderPublicSiteSettingsModal()}
        {this.renderTournamentAddToChampionshipModal()}
        {this.renderTournamentRemoveToChampionshipModal()}
        {this.renderCreateEventsForGroupModal()}
        {this.renderInformationModal()}
        {this.renderAddEventModal()}
        {this.renderDefaultGroupsModal()}
        {this.renderDeleteTournamentConfirmationModal()}
        {this.renderTournamentTagAssignModal()}
        {this.renderTournamentTagDeleteModal()}
        {this.renderReportsSelectionModal()}
        {this.renderExtendedTournamentScheduleReportFormModal()}
        {this.renderTournamentTeamMembersReportFormModal()}
        {this.renderTournamentParticipationConfirmationsReportFormModal()}
        {this.renderTournamentStartListReportFormModal()}
        {this.renderUnionMemberSchoolsStatisticsReportFormModal()}
        {this.renderUnionMemberSchoolsTournamentsReportFormModal()}
        {this.renderUnionMemberSchoolsTournamentsAsPartOfUnionReportFormModal()}
        {this.renderTournamentPlayersReportFormModal()}
        {this.renderHighLevelTournamentSchoolAdminsReportFormModal()}
        {this.renderTournamentScoreCardsReportFormModal()}
        {this.renderTournamentResultsIndividualReportFormModal()}
        {this.renderTournamentSchoolsReportFormModal()}
        {this.renderAssignEventNumbersModal()}
        <div className="row">
          <div className="col-md-12">{this.renderGrid()}</div>
        </div>
      </div>
    );
  }
}
